import React, {useEffect, useState} from 'react';
import {useLoading} from "../../components/context/LoadingContext";
import {collection, getDocs} from "firebase/firestore";
import {db, eventsCollectionName} from "../../components/Firebase/Firebase";
import EventsList from "./components/EventsList";
import {Button} from "@mui/material";
import {CiSquarePlus} from "react-icons/ci";
import {useNavigate} from "react-router-dom";

const EventsPage = () => {
    const [isLoading, setIsLoading] = useLoading(false);
    const navigate = useNavigate();

    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);

    useEffect(() => {
        fetchEvents();
    }, []);


    async function fetchEvents() {
        try {
            setIsLoading(true);
            const eventsCollectionRef = collection(db, eventsCollectionName);
            const snapshot = await getDocs(eventsCollectionRef);
            const eventsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            const now = new Date();

            const upcoming = eventsList
                .filter(e => new Date(e.startDate) >= now)
                .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

            const past = eventsList
                .filter(e => new Date(e.startDate) < now)
                .sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

            setUpcomingEvents(upcoming);
            setPastEvents(past);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleCreateEvent = () => {
        navigate(`/events/edit/new`, { state: { isNew: true } });
    };

    return (
        <div className='right-content'>
            <div className='card shadow border-0'>
                <div className="row d-flex align-items-center w-100">
                    <div className="col">
                        <h2 className='hd'>События</h2>
                    </div>
                    <div className="col d-flex justify-content-end">
                        <Button className="newObject" onClick={handleCreateEvent}>
                            <CiSquarePlus />
                        </Button>
                    </div>
                </div>

                {/* Предстоящие */}
                {upcomingEvents.length > 0 && (
                    <>
                        <h4 className='mt-4 mb-2'>Предстоящие</h4>
                        <div className='table-responsive'>
                            <EventsList
                                events={upcomingEvents}
                                onEventUpdated={fetchEvents}
                            />
                        </div>
                    </>
                )}

                {/* Прошедшие */}
                {pastEvents.length > 0 && (
                    <>
                        <h4 className='mt-5 mb-2'>Прошедшие</h4>
                        <div className='table-responsive'>
                            <EventsList
                                events={pastEvents}
                                onEventUpdated={fetchEvents}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default EventsPage;